import admin from './admin';

const api = {
  admin,
};

export default api;
